import ParkPassAPI from "../parkpassAxiosConfig";

export const getDisputes = async (params) => {
  try {
    return await ParkPassAPI.get("/v1/infractions/disputes/all", { params });
  } catch (error) {
    throw error;
  }
};

export const resolveDispute = async (disputeId, status, adminNotes, adminReply) => {
  try {
    return await ParkPassAPI.patch(
      `/v1/infractions/disputes/${disputeId}/resolve`,
      // admin_reply is a request-body field (citizen-visible); status and
      // admin_notes remain query params, matching the backend endpoint.
      { admin_reply: adminReply },
      { params: { status, admin_notes: adminNotes } }
    );
  } catch (error) {
    throw error;
  }
};
